import { render, staticRenderFns } from "./DropdownSelect.vue?vue&type=template&id=45ee671e&"
import script from "./DropdownSelect.vue?vue&type=script&lang=ts&"
export * from "./DropdownSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports